export const CurrencyFormatter = {
  /**
   * Formatter standard per gli Euro
   */
  EUR: new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 6,
  }),
};
